module.exports = __webpack_public_path__ + "media/images/icon/information-ba7362a85dd3ce862ee4f204bc75388d.svg";